function HeaderScrolled() {
	if (window.scrollY >= 30) {
		document.body.classList.add('scrolled');
	} else {
		document.body.classList.remove('scrolled');
	}
}

export default HeaderScrolled;
